module.exports = __webpack_public_path__ + "img/logo.aaab7f59.png";